import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import NotFound from 'components/NotFound';
import DepartureLocationEditForm from 'components/DepartureLocationEditForm';
import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';
import FormSkeleton from 'components/FormSkeleton';
import PageWithSidebar from 'components/PageWithSidebar';
import EntitySidebar from 'components/EntitySidebar';

import { withData } from 'lib';
import { SettingsDepartureLocationEditPageQuery } from '__generated__/SettingsDepartureLocationEditPageQuery.graphql';

const query = graphql`
  query SettingsDepartureLocationEditPageQuery($id: ID!) {
    departureLocation(id: $id) {
      name

      ...DepartureLocationEditForm_departureLocation
      ...EntitySidebar_entity
    }
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SettingsDepartureLocationEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [
  { link: '/settings', name: 'Nustatymai' },
  { link: '/settings/departure-locations', name: 'Išvykimo vietos' },
];

const SettingsDepartureLocationEditPage: FC<Props> = ({ preloadedQuery }) => {
  const { departureLocation } =
    usePreloadedQuery<SettingsDepartureLocationEditPageQuery>(
      query,
      preloadedQuery
    );

  if (!departureLocation) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<EntitySidebar entity={departureLocation} />}
      breadcrumbs={[
        ...breadcrumbs,
        {
          name: departureLocation.name,
        },
      ]}>
      <DepartureLocationEditForm departureLocation={departureLocation} />
    </PageWithSidebar>
  );
};

export default withData<SettingsDepartureLocationEditPageQuery, RouteParams>({
  query,

  loading: (
    <EntityEditPageSkeleton breadcrumbs={breadcrumbs}>
      <FormSkeleton sections={1} />
    </EntityEditPageSkeleton>
  ),

  variables: ({ routeParams }) => ({
    id: routeParams.id,
  }),
})(SettingsDepartureLocationEditPage);
